import { render, staticRenderFns } from "./studentTutor.vue?vue&type=template&id=2d226b1a&scoped=true"
import script from "./studentTutor.vue?vue&type=script&lang=js"
export * from "./studentTutor.vue?vue&type=script&lang=js"
import style0 from "./studentTutor.vue?vue&type=style&index=0&id=2d226b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d226b1a",
  null
  
)

export default component.exports